const prefixCache = new Map<string, string>();

function getSupplierPrefix(supplierName: string): string {
	const cached = prefixCache.get(supplierName);
	if (cached) return cached;
	const prefix = supplierName.replace(/\s/g, "").substring(0, 3).toUpperCase();
	prefixCache.set(supplierName, prefix);
	return prefix;
}

export function formatClarificationRef(
	supplierName: string | undefined,
	referenceNumber: number | undefined
): string {
	if (!supplierName || referenceNumber === undefined) {
		return "—";
	}
	return `${getSupplierPrefix(supplierName)}.${referenceNumber < 10 && "0"}${referenceNumber}`;
}
